import cn from 'classnames';
import { Option } from 'fp-ts/lib/Option';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

interface Props {
  q: Option<string>;
}

const NoResults: React.FC<Props> = ({ q }) => {
  const { t } = useTranslation();

  return (
    <div className="container jg-space-phms@md">
      <div className="row">
        <div
          className={cn(
            'jg-space-mtmd jg-space-mblg',
            'jg-space-mtlg@xl jg-space-mbxl@xl',
            'col-xs-12',
            'col-xl-8 offset-xl-2'
          )}
        >
          <h2
            className={cn(
              'jg-font-sizes--large jg-font-weight-light',
              'jg-space-mbmd'
            )}
          >
            <Trans i18nKey="noResults.title">
              Oops! We couldn’t find any results for -{' '}
              <strong>{{ q: q.toNullable() }}</strong>
            </Trans>
          </h2>
          <p className="jg-text--medium-light">
            <Trans i18nKey="noResults.text">
              Can’t find what you’re looking for?
              <br />
              Check your search query for errors and try again.
              <br />
              You can also visit{' '}
              <a
                href={t(
                  'noResults.helpUrl',
                  'https://help.justgiving.com/hc/en-us'
                )}
              >
                Help & support
              </a>{' '}
              for answers to common questions
            </Trans>
          </p>
        </div>
      </div>
    </div>
  );
};

export default NoResults;
